var map = {
	"./awepLogo/downloadAppleApp.svg": 9282,
	"./awepLogo/downloadGoogleApp.svg": 4492,
	"./awepLogo/logo.svg": 6955,
	"./qoutes.svg": 7631,
	"./vendor.svg": 4667,
	"./vendorB.svg": 2974,
	"./venue.svg": 9889,
	"./venueB.svg": 3612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;